(function ($) {

    let methods = {

        init: function (options) {
            // Establish our default settings
            let settings = $.extend({
                //element		 	 : null,
                list: null,
                url: '',
                data: {},
                elementClass: 'model',
                elementValuePair: null, // callback to extract value and label
                onShow: null,
                onBeforeFetch: null,
                onBeforeSend: null,
                onElementClick: null,
                onResultFetched: null,
                filter: false,
                selectElement: true,
                ignoredElementId: []
            }, options);

            let timer = null;
            let isRequesting = false;
            let defaultUrl = settings.url;

            return this.each(function () {
                // $(this).text( settings.text );
                let $this = $(this);

                if ($.isFunction(settings.complete)) {
                    settings.complete.call(this);
                }

                $this.on('show.bs.dropdown', function () {
                    if ($this.find(':input.dropdown-query').length > 0) {
                        setTimeout(function () {
                            $this.find(':input.dropdown-query').focus();
                        }, 100);
                    }

                    if ($.isFunction(options.onShow)) {
                        options.onShow(settings);
                    }

                    methods.fetch(settings, $this);
                });

                // empty query filter input when dropdown closed
                $this.on('hidden.bs.dropdown', function () {
                    if ($this.find(':input.dropdown-query').length > 0) {
                        $this.find(':input.dropdown-query').val('');
                    }
                });

                $this.find(options.list).on('click', '.' + settings.elementClass, function (e) {
                    e.preventDefault();

                    if (settings.selectElement) {
                        $(this).parents('.dropdown-menu:first').siblings('button')
                            .find('.dropdown-toggle-label').html(
                                ($.isFunction(settings.formatToggleLabel)) ?
                                    settings.formatToggleLabel($(this)) :
                                    $(this).text()
                            );
                    }

                    if ($.isFunction(settings.onElementClick)) {
                        settings.onElementClick($(this));
                    }

                    return settings.selectElement;
                });

                $this.on('click', '.dropdown-item-text, .dropdown-filter', function (event) {
                    event.stopPropagation();
                });

                $this.on('click', '.single-pagination a', function (e) {
                    e.preventDefault();

                    if (!$(this).hasClass('disabled')) {
                        settings.url = $(this).prop('href');
                        console.info(settings.url);
                        methods.fetch(settings, $this);
                    }

                    return false;
                });

                $(this).on('keyup', 'input.dropdown-query', function () {
                    let $input = $(this);
                    let $list = $this.find(settings.list);

                    clearTimeout(timer);

                    timer = setTimeout(function () {

                        if (!isRequesting) {
                            let data = queryString.parseUrl(settings.url);

                            _.set(data, 'query.query', $input.val());
                            _.set(data, 'query.page', 1);

                            let filterSettings = {
                                ...settings,
                                url:  `${data.url}?${queryString.stringify(data.query)}`
                            };

                            methods.fetch(filterSettings, $this);
                            // $.ajax({
                            //     url: defaultUrl,
                            //     type: "GET",//request is a POSt request
                            //     dataType: "json",//expect json as return
                            //     data: {query: $input.val()},
                            //     beforeSend: function (jqXHR, settings) {
                            //         isRequesting = true;
                            //
                            //         $list.children(':not(.dropdown-filter)').remove();
                            //
                            //         $list.append($('<div/>').addClass("spinner dropdown-item-text").append('<i class="spinners"></i> Loading...'));
                            //
                            //         if ($.isFunction(options.onBeforeSend)) {
                            //             options.onBeforeSend($(this), jqXHR, settings);
                            //         }
                            //     },
                            //     success: function (data) {
                            //         isRequesting = false;
                            //
                            //         //$input.siblings('i.fa').removeClass('ico ico-small ico-spinner').addClass('fa-search');
                            //
                            //         $list.find('.spinner').remove();
                            //
                            //         if (data.success != null && !data.success) {
                            //             $list.append($('<div class="dropdown-item-text"/>').append(data.message));
                            //         } else {
                            //             if (data.result.data.length > 0) {
                            //                 $.each(data.result.data, function (index, c) {
                            //                     methods.formatElement($list, options, c);
                            //                     //if($.inArray(c.id, ids) > -1) $list.find('li:last a').addClass('disabled');
                            //                 });
                            //
                            //                 methods.buildPagination($list, _.get(data.result, 'prev_page_url'), _.get(data.result, 'next_page_url'));
                            //             } else {
                            //                 $list.append($('<div class="dropdown-item-text"/>').append('No results found.'));
                            //             }
                            //
                            //             if ($.isFunction(settings.onResultFetched)) {
                            //                 settings.onResultFetched($(this), data);
                            //             }
                            //         }
                            //     }
                            // });
                        }
                    }, 500);
                })
            });
        },
        show: function () {
        },
        hide: function () {
        },
        update: function (content) {
        },
        fetch: function (options, $e) {
            let $list = $e.find(options.list);
            let filter = ($e.find('.dropdown-filter').length > 0);

            console.info(options.url, 'beforeFetch');

            if (options.ignoredElementId.length > 0) data["ignored"] = options.ignoredElementId.join();

            if ($.isFunction(options.onBeforeFetch)) {
                options.onBeforeFetch($list, options, $(this));
            }

            $.ajax({
                url: options.url,
                type: "GET",//request is a POSt request
                dataType: "json",//expect json as return
                data: options.data,
                beforeSend: function (jqXHR, settings) {
                    // 			if($list.children('li').length == 0)
                    if (filter) {
                        $list.children(':not(.dropdown-filter)').remove();
                        // $list.find('.dropdown-filter input.dropdown-query').val('');
                    } else {
                        $list.empty();
                    }

                    $list.append($('<div/>').addClass("spinner dropdown-item-text").append('<i class="spinners"></i> Loading...'));

                    if ($.isFunction(options.onBeforeSend)) {
                        options.onBeforeSend($(this), jqXHR, settings);
                    }
                },
                success: function (data) {
                    $list.find('.spinner').remove();

                    if (data.success != null && !data.success) {
                        $list.append($('<li class="dropdown-item-text"/>').append(data.message));
                    } else {
                        if (data.result.length > 0) {

                            $.each(data.result, function (index, c) {
                                methods.formatElement($list, options, c);
                                //if($.inArray(c.id, ids) > -1) $list.find('li:last a').addClass('disabled');
                            });

                            if(data.hasOwnProperty("pagination") && data.pagination) {
                                $list.append($('<div class="dropdown-divider"/>'));
                                $list.append($('<div class="dropdown-item-text dropdown-pagination"/>')
                                    .html(data.pagination));
                            }
                        } else {
                            $list.append($('<div class="dropdown-item-text"/>').append('No results found.'));
                        }

                        if ($.isFunction(options.onResultFetched)) {
                            options.onResultFetched($(this), data);
                        }
                    }
                }
            });
        },
        buildPagination: function ($list, prevPageUrl, nextPageUrl) {
            if (prevPageUrl || nextPageUrl) {
                $list.append($('<div class="dropdown-divider"/>'));
                $list.append($('<div class="dropdown-item-text dropdown-pagination"/>')
                    .append($(`<a href="${(prevPageUrl) ? prevPageUrl : '#'}" 
                            class="prev page-link ${prevPageUrl ? '' : 'disabled'}" />`)
                        .html('<i class="fas fa-caret-left"></i> Prev'))
                    .append($(`<a href="${(nextPageUrl) ? nextPageUrl : '#'}" 
                            class="next page-link ${nextPageUrl ? '' : 'disabled'}" />`)
                        .html('<i class="fas fa-caret-right"></i> Next'))
                );
            }
        },
        formatElement: function ($list, options, c) {
            let valuePair;

            if ($.isFunction(options.elementValuePair)) {
                valuePair = options.elementValuePair(c);
            } else {
                valuePair = {
                    value: c.id,
                    label: (c.hasOwnProperty('name_str')) ? c.name_str : c.name,
                    disabled: false
                };
            }

            if (!valuePair.disabled) {
                $item = $('<a class="dropdown-item"/>').addClass(options.elementClass).attr({
                    href: '#',
                    'data-id': valuePair.value,
                }).html(sprintf('%s', valuePair.label));
            } else {
                $item = $('<span class="dropdown-item disabled"/>').html(sprintf('%s', valuePair.label));
            }

            $list.append($item);
        }
    };

    $.fn.dropdownlist = function (method) {
        // Method calling logic
        if (methods[method]) {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + method + ' does not exist on jQuery.dropdownlist');
        }
    };

}(jQuery));
